<template>
  <div class="list-wrapper">
    <div class="content-wrapper">
      <div class="h-full">
        <XzTagGroup :data="statusWithAll" :active="outform.enableFlag"
          @handleClick="(v) => handleOutChange('enableFlag', v)">
          <span class="title">商品状态</span>
        </XzTagGroup>
        <div class="table-wrapper" :class="{ 'fullscreen': isFullScreen }">
          <xz-table ref="xzTable" :columns="columnLists" :data="data" :searchAttrs="searchAttrs"
            :searchVal.sync="outform.nameOrSnOrModelOrSimpleSpecs" :toolsAttrs="toolsAttrs" :drawerVisible.sync="drawerVisible"
            :scroll="{ x: '100%', y: scrollHeight }" :drawerWidth="460" @search="() => handleOutChange()" rowKey="id"
            @refresh="handleReset" @fullScreen="handleFullScreen" class="wrap">
            <template #buttons>
              <a-button v-if="$withPermission('gongxutong:base_goods:goods:add')" @click="handleCreate" type="primary">新增</a-button>
            </template>
            <template #drawer>
              <div style="flex: 1; overflow: auto" class="advanced-search">
                <a-form-model :model="form" ref="searchRef" :label-col="labelCol" :wrapper-col="wrapperCol" :colon="false">
                  <a-form-model-item label="商品编码">
                    <a-input v-model="form.sn" placeholder="请输入" allow-clear />
                  </a-form-model-item>
                  <a-form-model-item label="型号">
                    <a-input v-model="form.model" placeholder="请输入" allow-clear />
                  </a-form-model-item>
                  <a-form-model-item label="规格">
                    <a-input v-model="form.simpleSpecs" placeholder="请输入" allow-clear />
                  </a-form-model-item>
                  <a-form-model-item label="品牌">
                    <a-input v-model="form.brandName" placeholder="请输入" allow-clear />
                  </a-form-model-item>
                  <a-form-model-item label="原厂备件号">
                    <a-input v-model="form.storeSn" placeholder="请输入" allow-clear />
                  </a-form-model-item>
                  <a-form-model-item label="是否医疗件">
                    <a-select v-model="form.medicalFlag" placeholder="请选择">
                      <a-select-option value="">全部</a-select-option>
                      <a-select-option :value="1">是</a-select-option>
                      <a-select-option :value="0">否</a-select-option>
                    </a-select>
                  </a-form-model-item>
                  <a-form-model-item label="商品分类">
                    <ChooseGoodsCategory ref="chooseGoodsCategoryRef" checkStrictly @handleSelect="handleSelectCategory" />
                  </a-form-model-item>
                  <a-form-model-item label="产品注册证号">
                    <a-input v-model="form.registerCode" placeholder="请输入" allow-clear />
                  </a-form-model-item>
                  <a-form-model-item label="创建人">
                    <a-input v-model="form.createUserName" placeholder="请输入" allow-clear />
                  </a-form-model-item>
                  <a-form-model-item label="创建时间">
                    <el-date-picker
                      v-model="timeArr"
                      type="daterange"
                      range-separator="-"
                      value-format="yyyy-MM-dd"
                      start-placeholder="开始日期"
                      end-placeholder="结束日期"
                      style="width: 100%;">
                    </el-date-picker>
                  </a-form-model-item>
                </a-form-model>
              </div>
              <div style="text-align: right; height: 68px; line-height: 68px">
                <a-button @click="handleEmpty">
                  重置
                </a-button>
                <a-button type="primary" style="margin-left: 10px;" @click="handleAdvancedQuery">
                  确定
                </a-button>
              </div>
            </template>
            <template #custom>
              <tableHeaderConfiguration businessType="goodsManagement" :baseLists="baseLists" @updateColumnList="updateColumnList" />
            </template>
            <template slot="imageList" slot-scope="imageList">
              <span v-if="imageList && imageList.length > 0">
                <el-image
                  :src="imageList[0].url"
                  :preview-src-list="imageList.map(img => img.url)"
                  style="width: 32px; height: 32px; margin-right: 5px;"
                />
                <template v-if="imageList.length > 1">...</template>
              </span>
              <span v-else>暂无图片</span>
            </template>
            <template slot="sn" slot-scope="sn, record">
              <div @click="handleGoodsDetail(record.id)" class="code">{{ sn }}</div>
            </template>
            <template slot="enableFlag" slot-scope="enableFlag, record">
              <span :class="['c_tag', `status-${enableFlag}`]">
                {{ record.enableFlagDesc }}
              </span>
            </template>
            <template slot="storeSnTitle">
              原厂备件号
              <a-tooltip placement="top">
                <template slot="title">
                  <span>备件码</span>
                </template>
                <a-icon type="exclamation-circle" style="font-size: 14px; color: #8c8c8c;" />
              </a-tooltip>
            </template>
            <template slot="storeSn" slot-scope="storeSn">
              {{ storeSn }}
            </template>
            <template slot="action" slot-scope="text, record">
              <el-button v-if="$withPermission('gongxutong:base_goods:goods:edit')" @click="handleAction('edit', record)" type="text" size="medium">编辑</el-button>
              <el-button v-if="$withPermission('gongxutong:base_goods:goods:enable') && record.enableFlag === 0" @click="handleAction('enable', record)" type="text" size="medium">启用</el-button>
              <el-button v-if="$withPermission('gongxutong:base_goods:goods:disable') && record.enableFlag === 1" @click="handleAction('disabled', record)" type="text" size="medium">禁用</el-button>
              <el-button v-if="$withPermission('gongxutong:base_goods:goods:del')" @click="handleAction('delete', record)" type="text" size="medium">删除</el-button>
            </template>
          </xz-table>
        </div>
      </div>
    </div>
    <div class="pagination-wrapper">
      <a-pagination :current="page.pageNum" :total="total" :show-total="total => `共 ${total} 条`" show-size-changer :pageSizeOptions="['10', '20', '30', '50', '100']" show-quick-jumper :pageSize.sync="page.pageSize" @change="handleNumChange" @showSizeChange="handleSizeChange" />
    </div>

    <EditDialog ref="editDialogRef" @refresh="handleSearch" />

    <ForbidDialog ref="forbidDialogRef" :info="currentRow" @change="handleForbid" />

    <GoodsDetailDialog ref="goodsDetailDialogRef" :id="currentId" />
  </div>
</template>

<script>
import { skuPageList, enableOrDisable, deleteSku } from '@/api/goods';
import xzTable from '@/components/xiaozi-ui/xz-table/src/table.vue';
import XzTagGroup from '@/components/xiaozi-ui/xz-tag-group';
import * as Moment from 'dayjs';
import { mapGetters } from 'vuex';
import tableHeaderConfiguration from '@/components/tableHeaderConfiguration.vue';
import EditDialog from './components/editDialog.vue';
import ForbidDialog from './components/forbidDialog.vue';
import ChooseGoodsCategory from './components/chooseGoodsCategory.vue';
import GoodsDetailDialog from './components/goodsDetailDialog.vue';

const COMMON_COLUMNS = [
  {
    title: '商品图片',
    dataIndex: 'imageList',
    key: 'imageList',
    width: 100,
    ellipsis: true,
    scopedSlots: { customRender: 'imageList' },
  },
  {
    title: '商品编码(sku)',
    dataIndex: 'sn',
    key: 'sn',
    width: 130,
    ellipsis: true,
    scopedSlots: { customRender: 'sn' },
  },
  {
    title: '商品名称',
    dataIndex: 'goodsName',
    key: 'goodsName',
    width: 160,
    ellipsis: true,
    customRender: text => {
      return text || '--';
    },
  },
  {
    title: '商品别名',
    dataIndex: 'anotherName',
    key: 'anotherName',
    width: 100,
    ellipsis: true,
    customRender: text => {
      return text || '--';
    },
  },
  {
    title: '型号',
    dataIndex: 'model',
    key: 'model',
    width: 80,
    ellipsis: true,
    customRender: text => {
      return text || '--';
    },
  },
  {
    title: '规格',
    dataIndex: 'simpleSpecs',
    key: 'simpleSpecs',
    width: 80,
    ellipsis: true,
    customRender: text => {
      return text || '--';
    },
  },
  {
    title: '品牌',
    dataIndex: 'brandName',
    key: 'brandName',
    width: 120,
    ellipsis: true,
    customRender: text => {
      return text || '--';
    },
  },
  {
    title: '计量单位',
    dataIndex: 'goodsUnit',
    key: 'goodsUnit',
    width: 100,
    ellipsis: true,
    customRender: text => {
      return text || '--';
    },
  },
  {
    originTitle: '原厂备件号',
    dataIndex: 'storeSn',
    key: 'storeSn',
    width: 120,
    ellipsis: true,
    scopedSlots: { title: 'storeSnTitle', customRender: 'storeSn' },
  },
  {
    title: '是否医疗件',
    dataIndex: 'medicalFlag',
    key: 'medicalFlag',
    width: 110,
    ellipsis: true,
    customRender: text => {
      return text ? '是' : '否';
    },
  },
  {
    title: '商品分类',
    dataIndex: 'merchantGoodsCategoryName',
    key: 'merchantGoodsCategoryName',
    width: 200,
    ellipsis: true,
    customRender: text => {
      return text && text.length ? text.join('>') : '--';
    },
  },
  {
    title: '产品注册证/备案凭证',
    dataIndex: 'registerCode',
    key: 'registerCode',
    width: 170,
    ellipsis: true,
    customRender: text => {
      return text || '--';
    },
  },
  {
    title: '商品状态',
    dataIndex: 'enableFlag',
    key: 'enableFlag',
    width: 100,
    ellipsis: true,
    scopedSlots: { customRender: 'enableFlag' },
  },
  {
    title: '创建人',
    dataIndex: 'createUserName',
    key: 'createUserName',
    width: 80,
    ellipsis: true,
    customRender: (text) => {
      return text || '--';
    },
  },
  {
    title: '创建时间',
    dataIndex: 'createTime',
    key: 'createTime',
    width: 170,
    ellipsis: true,
    customRender: (text) => {
      return text ? Moment(text * 1).format('YYYY-MM-DD HH:mm:ss') : '--';
    },
  },
];

export default {
  name: 'GOODS',
  components: {
    xzTable,
    XzTagGroup,
    tableHeaderConfiguration,
    EditDialog,
    ForbidDialog,
    ChooseGoodsCategory,
    GoodsDetailDialog,
  },
  computed: {
    ...mapGetters(['actionPermissionMap']),
    toolsAttrs () {
      return {
        refresh: true,
        zoom: true,
        fullScreen: this.isFullScreen,
        advancedSearch: true,
        custom: true,
      };
    },
  },
  watch: {
    drawerVisible (v) {
      if (v) {
        this.form = { ...this.outform };
      }
    },
  },
  data () {
    return {
      columnLists: [
        ...COMMON_COLUMNS,
      ],
      baseLists: [
        ...COMMON_COLUMNS,
      ],
      data: [],
      outform: {
        enableFlag: '',
        nameOrSnOrModelOrSimpleSpecs: '',
      },
      currentId: '',
      form: {
        sn: '',
        model: '',
        simpleSpecs: '',
        brandName: '',
        storeSn: '',
        medicalFlag: '',
        merchantGoodsCategoryId: '',
        registerCode: '',
        createUserName: '',
        createTimeStart: '',
        createTimeEnd: '',
      },
      total: 0,
      searchAttrs: {
        show: true,
        placeholder: '商品名称/编码/型号/规格',
        data: 'nameOrSnOrModelOrSimpleSpecs',
      },
      drawerVisible: false,
      labelCol: { span: 6 },
      wrapperCol: { span: 16 },
      statusWithAll: [
        {
          label: '全部',
          value: '',
        },
        {
          label: '已启用',
          value: 1,
        },
        {
          label: '已禁用',
          value: 0,
        },
        {
          label: '草稿',
          value: 2,
        },
      ],
      page: {
        pageSize: 10,
        pageNum: 1,
      },
      scrollHeight: 600,
      isFullScreen: false,
      currentRow: {},
      timeArr: [],
    };
  },
  methods: {
    handleCreate () {
      this.$refs.editDialogRef.init();
      this.$refs.editDialogRef.dialogVisible = true;
    },
    handleGoodsDetail (id) {
      if (this.$withPermission('gongxutong:base_goods:goods:detail')) {
        this.currentId = id;
        this.$refs.goodsDetailDialogRef.dialogVisible = true;
      }
    },
    updateColumnList (columnList) {
      this.columnLists = [
        ...columnList,
        {
          title: '操作',
          dataIndex: 'action',
          key: 'action',
          fixed: 'right',
          width: 160,
          scopedSlots: { customRender: 'action' },
        },
      ];
    },
    handleSelectCategory (v) {
      const categoryId = v.value.slice(-1)[0];
      this.form.merchantGoodsCategoryId = categoryId;
    },
    handleAction (type, row) {
      if (type === 'delete') {
        this.$confirm(`确认删除【${row.goodsName}_${row.sn}】吗？`, '删除', {
          confirmButtonText: '确认',
          cancelButtonText: '取消',
          type: 'warning',
        }).then(async () => {
          await deleteSku({id: row.id});
          this.$message.success('操作成功！');
          this.handleSearch();
        });
      }
      if (type === 'enable') {
        this.$confirm(`确认启用【${row.goodsName}_${row.sn}】吗？`, '启用', {
          confirmButtonText: '确认',
          cancelButtonText: '取消',
          type: 'warning',
        }).then(async () => {
          await enableOrDisable({
            id: row.id,
            enableFlag: 1,
          });
          this.$message.success('商品已启用！');
          this.handleSearch();
        });
      }
      if (type === 'disabled') {
        this.$refs.forbidDialogRef.dialogVisible = true;
        this.currentRow = row;
      }
      if (type === 'edit') {
        // 跳转详情页
        this.$refs.editDialogRef.initForm(row.id);
        this.$refs.editDialogRef.dialogVisible = true;
      }
    },
    async handleForbid (v) {
      await enableOrDisable({
        id: this.currentRow.id,
        enableFlag: 0,
        downFlag: !!v || false,
      });
      this.$message.success('商品已禁用！');
      this.handleSearch();
    },
    handleEmpty () {
      this.form = this.$options.data().form;
      this.timeArr = [];
      this.$refs.chooseGoodsCategoryRef.defaultValue = [];
    },
    handleReset () {
      this.outform = {
        ...this.$options.data().form,
      };

      this.page.pageNum = 1;
      this.page.pageSize = 10;

      this.handleSearch();
    },
    handleAdvancedQuery () {
      this.page.pageNum = 1;

      this.form.enableFlag = this.form.enableFlag === undefined ? '' : this.form.enableFlag;

      this.handleSearch(this.form);

      this.$nextTick(() => {
        this.outform = { ...this.form };
      });
    },
    handleSizeChange (_, size) {
      this.page.pageSize = size;

      this.handleSearch();
    },
    handleNumChange (num) {
      this.page.pageNum = num;

      this.handleSearch();
    },
    async handleSearch (form = this.outform) {
      this.data = [];
      const { body } = await skuPageList({
        ...form,
        createTimeStart: this.timeArr?.length ? new Date(this.timeArr[0]).getTime() : '',
        createTimeEnd: this.timeArr?.length ? new Date(this.timeArr[1]).getTime() + 1000 * 60 * 60 * 24 : '',
        ...this.page,
        orderBy: [{
          orderByProperty: 'createTime',
          orderByType: 'DESC',
        }],
      });

      this.data = body?.list || [];

      this.total = +body?.total || 0;

      if (this.drawerVisible) {
        this.drawerVisible = false;
      }
    },
    handleOutChange (key, o) {
      if (key) {
        this.outform[key] = o.value;
      }

      this.page.pageNum = 1;

      this.handleSearch();
    },
    handleFullScreen (flag) {
      this.isFullScreen = flag;
    },
  },
  mounted () {
    this.handleSearch();
  },
};
</script>
<style scoped lang="scss">
@mixin tag_round() {
  padding: 4px 8px;
  border-radius: 4px;
}

.list-wrapper {
  height: 100%;
  display: flex;
  flex-direction: column;

  .content-wrapper {
    flex: 1;
    overflow: hidden;
    padding: 0 0 8px;

    .h-full {
      height: 100%;
      background-color: #fff;
      display: flex;
      flex-direction: column;

      .title {
        font-size: 14px;
        font-weight: 600;
        padding-right: 2em;
      }

      .table-wrapper {
        padding: 16px 12px;
        flex: 1;
        overflow: auto;

        .ant-radio-button-wrapper {
          border-width: 0;
          background-color: #F2F4F7;

          &.active-radio {
            border-color: #E2F3FE;
            background-color: #E2F3FE;
            color: #237FFA;
          }
        }

        .ant-radio-button-wrapper:not(:first-child)::before {
          width: 0;
        }

        .code {
          cursor: pointer;
          color: #237FFA;
        }

        .c_tag {
          @include tag_round();
          margin-right: 0.2em;
        }

        .status-0 {
          @include tag_round();
          background-color: #FEE9E5;
          color: #FF5959;
        }

        .status-1 {
          @include tag_round();
          background-color: #E5FEEB;
          color: #14CA64;
        }

        .status-2 {
          @include tag_round();
          color: #1F2733;
          background-color: #F2F4F7;
        }
      }
      .table-wrapper.fullscreen {
        position: fixed;
        left: 0;
        right: 0;
        bottom: 0;
        top: 0px;
        z-index: 100;
        background: #FFFFFF;
      }
    }
  }
}

/deep/.ant-table-body::-webkit-scrollbar {
  height: 12px;
  width: 12px;
}

/deep/ .ant-table-body::-webkit-scrollbar-thumb {
  border-radius: 8px;
  box-shadow: inset 0 0 5px #C9CED6;
  background: #C9CED6;
}

//鼠标移入样式
/deep/ .ant-table-body::-webkit-scrollbar-thumb:hover {
  background: #C9CED6;
}

.advanced-search {
  .ant-form-item {
    margin-bottom: 8px;
  }
}

/deep/.ant-drawer-body {
  padding: 16px;
}
</style>
